import React, {useContext, useMemo, useRef, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {CitizenContext} from "../context/citizen-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {useQuery} from "@tanstack/react-query";
import citizenService from "../../../../../../services/web/citizen-service.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const CitizenRole = () => {
    const {citizen} = useContext(CitizenContext);
    const navigate = navigateHook();

    const {data} = useQuery({
        queryFn: () => citizenService.programUsers(citizen.protectionProgram.map(p => p.value)),
        queryKey: ["user", {protectionProgram: citizen.protectionProgram}],
        enabled: !!citizen?.protectionProgram?.length
    });

    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {
            field: "name", headerName: "Nome", flex: 2,
            cellRenderer: ({data, value}) => (
                <span
                    className="underline cursor-pointer"
                    onClick={() => navigate("/user-agents/form/" + data.id, "/user-agents/" + data.id + "/edit", true)}
                >
                    {value}
                </span>
            )
        },
        {
            field: "phones",
            headerName: "Telefones",
            flex: 1,
            valueFormatter: ({value}) => {
                const phones = JSON.parse(value.value)
                return phones.map(p => projectUtils.formatPhone(p)).join(", ")
            }
        }
    ]);

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Agentes que receberão os alertas no APP</Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-189px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowHeight={35}
                            rowData={data ?? []}
                            columnDefs={columnDefs}
                            paginationAutoPageSize={true}
                            pagination={true}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default CitizenRole;